var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7998 11.2V10.5C23.7998 7.3625 19.0748 5 12.7998 5C6.5248 5 1.7998 7.3625 1.7998 10.5V15.5C1.7998 18.1125 5.0748 20.1875 9.7998 20.8125V21.5C9.7998 24.6375 14.5248 27 20.7998 27C27.0748 27 31.7998 24.6375 31.7998 21.5V16.5C31.7998 13.9125 28.6248 11.8375 23.7998 11.2ZM9.7998 18.775V15.8125C10.7946 15.9403 11.7968 16.003 12.7998 16C13.8028 16.003 14.805 15.9403 15.7998 15.8125V18.775C14.8074 18.9296 13.8042 19.0049 12.7998 19C11.7954 19.0049 10.7922 18.9296 9.7998 18.775V18.775ZM21.7998 13.7375V15.5C21.7998 16.55 20.2498 17.675 17.7998 18.3625V15.4375C19.4123 15.05 20.7748 14.4625 21.7998 13.7375V13.7375ZM3.7998 15.5V13.7375C4.8248 14.4625 6.1873 15.05 7.7998 15.4375V18.3625C5.3498 17.675 3.7998 16.55 3.7998 15.5ZM11.7998 21.5V20.975L12.7998 21C13.2915 21 13.7665 20.9875 14.2248 20.9625C14.7248 21.1375 15.2498 21.2875 15.7998 21.425V24.3625C13.3498 23.675 11.7998 22.55 11.7998 21.5ZM17.7998 24.775V21.8C18.7945 21.9305 19.7966 21.9973 20.7998 22C21.8028 22.003 22.805 21.9403 23.7998 21.8125V24.775C21.8111 25.075 19.7886 25.075 17.7998 24.775ZM25.7998 24.3625V21.4375C27.4123 21.05 28.7748 20.4625 29.7998 19.7375V21.5C29.7998 22.55 28.2498 23.675 25.7998 24.3625V24.3625Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarn);
export default __webpack_public_path__ + "static/media/Earn.f2cf8228a07172636da505f8926199ee.svg";
export { ForwardRef as ReactComponent };